import { default as api } from 'config/adminApiConf.js';

export const listForumService = async (page) => {
	try {
		let result = await api.get(`/forum/list?page=${page}`);
		return result;
	} catch (error) {
		return error;
	}
};

export const deleteForumService = async (id) => {
	try {
		let result = await api.delete(`/forum/delete/${id}`);
		return result;
	} catch (error) {
		return error;
	}
};
